import { BreakBlock, ImageBlock, CodeBlock } from "../Blocks";

export default (setEditorState, editorState, extraProps, onPopper, setReadOnly) => (contentBlock) => {
    
    const type = contentBlock.getType();
    // console.log('[renderer.js]', type)
    switch (type) {
        case 'BREAK': 
            return {
                component: BreakBlock,
                editable: false,
            };
        case 'IMAGE': 
            return {
                component: ImageBlock,
                editable: false,
                props: {
                    setEditorState,
                    editorState,
                    onPopper,
                    extraProps
                },
            };
        case 'code-block':
            return {
                component: CodeBlock,
                editable: true,
                props: {
                    setEditorState,
                    editorState,
                    onPopper,
                    setReadOnly,
                    extraProps
                },
            }
        default: return null;
    }
};
